import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DraggableDialog from '../DraggableDialog/DraggableDialog';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import * as actions from '../../../../store/index';
import { Grid, Tab, Tabs } from '@material-ui/core';
import UsersPanel from './UsersPanel';
import UsersStats from './UsersStats';
import RegisterDialog from './RegisterUsers/RegisterDialog';

const useStyles = makeStyles((theme) => ({
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.secondary.main,
    alignItems: 'center',
  },
  gridContainer: {
    minHeight: '30vh',
  },
}));

function TabPanel({ children, value, index }) {
  if (value !== index) return null;

  return (
    <div role='tabpanel' id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`}>
      {children}
    </div>
  );
}

function UserManagement({ open }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const notifications = useSelector((state) => state.gui.notifications);

  const [tabIndex, setTabIndex] = useState(0);
  const [newRow, setNewRow] = useState(false);
  const [editUser, setEditUser] = useState(null);

  const closeUsersDialog = useCallback(() => {
    dispatch(actions.setActiveDialog(null));
    dispatch(actions.setNotifications([]));

    notifications.forEach((notification) => {
      dispatch(actions.deleteNotification(notification.id));
    });
  }, [dispatch, notifications]);

  const dialogActions = useMemo(
    () => [
      {
        onClick: closeUsersDialog,
        color: 'primary',
        label: t('Console.close'),
      },
    ],
    [closeUsersDialog, t]
  );

  return (
    <DraggableDialog
      maxWidth='xl'
      title={t('users.title')}
      open={open}
      actions={dialogActions}
      onClose={closeUsersDialog}>
      <Grid
        container
        direction='row'
        justifyContent='space-evenly'
        alignItems='flex-start'
        spacing={1}
        className={classes.gridContainer}>
        <Grid item xs={1}>
          <Tabs
            className={classes.tabs}
            orientation='vertical'
            value={tabIndex}
            onChange={(_, newVal) => setTabIndex(newVal)}>
            <Tab label={t('users.title')} id='filters' style={{ alignSelf: 'center', padding: 0 }} />
            <Tab label={t('users.user_stats')} id='report' style={{ alignSelf: 'center', padding: 0 }} />
          </Tabs>
        </Grid>
        <Grid item xs={11}>
          <TabPanel value={tabIndex} index={0}>
            <UsersPanel newRow={newRow} setNewRow={setNewRow} editUser={editUser} setEditUser={setEditUser} />
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <UsersStats />
          </TabPanel>
        </Grid>
      </Grid>
      <RegisterDialog newRow={newRow} setNewRow={setNewRow} editUser={editUser} setEditUser={setEditUser} />
    </DraggableDialog>
  );
}

export default UserManagement;
